import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'

const ls = LocalizationStore.getInstance()

export function getQuestionnairePrefillFormSchema(): any {
    return {
        'title': ls.t!('Add questionnaire'),
        'type': 'object',
        'required': [
            'termCountMonthsPrefill'
        ],
        'properties': {
            'pinPrefill': {
                'title': ls.t!('pinPrefill'),
                'type': 'string',
                'maxLength': 7
            },
            'phonePrefill': {
                'title': ls.t!('phone'),
                'type': 'string'
            },
            'termCountMonthsPrefill': {
                'title': ls.t!('termCountMonthsPrefill'),
                'type': 'integer',
                'minimum': 1,
                'maximum': 100,
                'default': 6
            }
        }
    }
}

export const UIQuestionnairePrefillFormSchema = {
    'externalClientKeyPrefill': {
        'ui:widget': 'updown'
    },
    'termCountMonthsPrefill': {
        'ui:widget': 'updown'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        if (error['name'] === 'maxLength') {
            error['message'] = ls.t('maximum number of characters has been exceeded')
        }
        return error
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/QuestionnairePrefillForm.tsx